import { ComponentProps, ReactElement } from 'react';

import Table from '@/common/Table';
import { getClasses } from '@/utils';

export type CustomPdfTableHeaderProps = Omit<ComponentProps<typeof Table.Row>, 'header'> & {};

const CustomPdfTableHeader = ({ ...props }: CustomPdfTableHeaderProps): ReactElement => {
  return (
    <Table.Row {...props} header className={getClasses('CustomPdfTable-Header', props.className)}>
      <Table.Cell className="INDEX">NO.</Table.Cell>
      <Table.Cell className="TYPE">Item Type</Table.Cell>
      <Table.Cell className="NOTE">Notes</Table.Cell>
      <Table.Cell className="COST">Cost</Table.Cell>
    </Table.Row>
  );
};

export default CustomPdfTableHeader;
